module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_005.png
// module id = 2352
// module chunks = 5